import React from "react";
import { Heading } from "../../../subComponents/Heading";

export default function InHouseFacilityAndStrength() {
  return (
    <section className="inhouse-section">
      <Heading title={<>Our Strength</>} style={{ textAlign: "center",textDecoration:"underline" }} />
      <br />
      <div className="inhouse-container">
        <ul style={{ listStyle: "none", display:"flex", flexDirection:"column",gap:"1rem",textAlign:"center" }}>
          <li>
            ◉ &nbsp; Import substitute developed for many parts under vocal for
            localcampaign.
          </li>
          <li> ◉ &nbsp; Ability to develop special components in short time.</li>
          <li> ◉ &nbsp; Cost effective solutions.</li>
          <li>
            ◉ &nbsp; Facilities for automotive tubes and assemblies right from
            extrusion to
          </li>
          <li> ◉ &nbsp; assembly under one roof.</li>
          <li> ◉ &nbsp; Technology to supply defect free parts.</li>
          <li>
            ◉ &nbsp; Our belief is in Right Product at right Price at right time
            delivery for utmost
          </li>
          <li> ◉ &nbsp; customer satisfaction.</li>
          <li>
            ◉ &nbsp; Last but not least our foremost strength is our Satisfied
            customers.
          </li>
        </ul>
      </div>
    </section>
  );
}
